export default () => ({
	username: null,

	email: null,

	// When true, it means we've fetched settings and set all
	// the things for this client and we can start render views
	isReady: false,

	// If we don't have settings for this client, show special error message
	// and don't render views
	nonexistentSettings: false,

	// Global loading when the whole app is loading
	// e.g. when changing locales
	loading: [],

	// Messages to communicate success / error / warning to user
	messages: [],

	tenantId: null,

	settings: null,

	isMenuVisible: false,

	// Permissions of particular logged in user
	permissions: null
})
